import styled from '@emotion/styled/macro';

export const Text = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.body};
  line-height: ${({ theme }) => theme.lineHeights.body};
  color: ${({ theme }) => theme.colors.greyDark};

  p + p {
    margin-top: ${({ theme }) => theme.space[4]};
  }
`;
